<template>
  <div>
    <!-- TOP NAVIGATION -->
    <TopNavigation />

    <div id="wrapper">
      <!-- SIDE BARD NAVIGATION -->
      <SideNavigation />

      <div
        id="content-wrapper"
        class="d-flex flex-column"
      >
        <div id="content">
          <!-- Content Row -->
          <main class="py-0 offset-0">
            <router-view />
          </main>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <Footer />
    <!-- End of Footer -->
  </div>
</template>

<script>
    //@todo import this for the future use in the view crew and staff

    import Footer from './Footer';
    import TopNavigation from './TopNavigation';
    import SideNavigation from './SideNavigation';

    export default {
        name: 'Home',
        components: {SideNavigation, TopNavigation, Footer},
        computed:{
            isLoggedIn: function() {
                return this.$store.getters.isLoggedIn;
            }
        },
        mounted:function() {
            $("#sidebarToggle, #sidebarToggleTop").on('click', function(e) {
                $("body").toggleClass("sidebar-toggled");
                $(".sidebar").toggleClass("toggled");
                if ($(".sidebar").hasClass("toggled")) {
                    $('.sidebar .collapse').collapse('hide');
                }
            });

            // Close any open menu accordions when window is resized below 768px
            $(window).resize(function() {
                if ($(window).width() < 768) {
                    $('.sidebar .collapse').collapse('hide');
                }
            });

            // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
            $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function(e) {
                if ($(window).width() > 768) {
                    var e0 = e.originalEvent, delta = e0.wheelDelta || -e0.detail;
                    this.scrollTop += (delta < 0 ? 1 : -1) * 30;
                    e.preventDefault();
                }
            });
        }
    };
</script>

<style scoped>

</style>
